"use client";

import { useEffect, useRef } from "react";
import { Button } from "@/app/components/ui";
import styles from "./CTASection.module.css";

export default function EmbedCTASection({ isAuthenticated = false }) {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add(styles.visible);
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className={styles.cta}>
      <div className={styles.container} ref={sectionRef}>
        <h2 className={styles.title}>Host your videos with Flare</h2>

        <p className={styles.description}>
          Embed anywhere, customize the player, and learn from every viewer. Free to start.
        </p>

        <div className={styles.buttons}>
          <Button
            variant="attention"
            size="lg"
            className={styles.ctaButton}
            href={isAuthenticated ? "/library" : "/register"}
          >
            {isAuthenticated ? "Go to library" : "Try it free"}
          </Button>
        </div>
      </div>
    </section>
  );
}
